import { render, staticRenderFns } from "./shipping_addresses_edit.vue?vue&type=template&id=676f27ee&scoped=true&"
import script from "./shipping_addresses_edit.vue?vue&type=script&lang=js&"
export * from "./shipping_addresses_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f27ee",
  null
  
)

export default component.exports